import { validators } from '../../utils/validators';

export const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};

    if (REQUIRED(values) || REQUIRED(values.fileName)) {
        errors.fileName = 'Please enter a File Name';
    }

    if (values.fileName && values.fileName.length > 25) {
        errors.fileName = 'Max 25 character are allowed in filename';
    }
    const isValid = /^[A-Za-z0-9\d\-_\s]+$/i.test(values.fileName);

    if (!isValid) {
        errors.fileName =
            'Only numbers, letters, - & _ are allowed in filename';
    }

    if (!/^\S+$/.test(values.fileName)) {
        errors.fileName = 'Spaces not allowed in filename';
    }
    return errors;
};
